var global = require('../internals/global');
var isObject = require('../internals/is-object');

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/an-object.js
// module id = 272
// module chunks = 25